export default [

     {
          path: '/group-risk',
          name: 'GroupRisk',
          component: () => import("@/views/Page/GroupRisk/GroupRisk.vue"),
          meta: {
               title: 'Risk Group',
          },
     }
];